import { Injectable } from '@angular/core';
import { PickManagementBackendService } from './pick-management-backend.service';
import { PickManagementDataService } from './pick-management-data.service';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DetailedEntityDataEditorService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { MultiColumnPopupComponent } from '../../../../shared/lookup/multi-column-popup/multi-column-popup.component';
import { PropertyChangeEvent } from '../../../../shared/models/property-change-event';
import { CASE_ID_CONFIG_KEY, COMMON_FIELDS, LOTTABLE_FIELDS, META_DATA, PICK_MNGT_CONSTANTS, SEARCH_OPERATORS, TABLE_NAMES } from '../../../../constants';
import { SEARCH_DEFAULT_PAGE_NUMBER, SEARCH_DEFAULT_PAGE_SIZE, SORT_ORDER_ASC } from '../../../../shared/search/search-constants';
import { HttpStatusCode } from '../../../../shared/models/http-status-code.constants';
import { COMMONPROPERTIES } from '../../../../shared/models/common-fields';


@Injectable()
export class PickManagementDataEditorService extends DetailedEntityDataEditorService {
  public backendService: PickManagementBackendService;
  public dataService: PickManagementDataService;
  private channelId: any;  
  public isCaseIDEditable: boolean;
  public lottable01: string;
  public lottable02: string;
  public lottable03: string;
  public lottable04: string;
  public lottable05: string;
  public lottable06: string;
  public lottable07: string;
  public lottable08: string;
  public lottable09: string;
  public lottable10: string;
  public lottable11: string;
  public lottable12: string;
  public lottable13: string;
  public lottable14: string;
  public lottable15: string;
  public isQuantityEditable: boolean;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public setDependentServices(dataService, backendService) {
    this.dataService = dataService;
    this.backendService = backendService;
  }
  /* public setDataService(dataService) {
    this.dataService = dataService;
  }

  public setBackendService(backendService) {
    this.backendService = backendService;
  } */

  /* This method is called to populate any restricted values
  Here we need to populate restricted values for orderLineNo and Lot fields.
  These values will be static for a particular orderKey.
  These restricted values differ from UOM and pack key in ASN document.
  The below method will be invoked when the table mode is changed to Edit.*/
  // public populateRestrictedValues(pageRows: any, colName: any) {
  //   this.dataService.lookupMap.keyArray = ['key', 'value'];
  //   switch (colName) {
  //     case 'orderLineNo': {
  //       this.dataService.lookupMap.skuMap = [];
  //       const orderId = this.dataService.getPrimarySelectedDocument();
  //       this.backendService.populateRestrictedValuesForOrderLine(orderId).subscribe((res: any) => {
  //         this.dataService.lookupMap.orderLines = res.orderLines;
  //         this.dataService.lookupMap.orderLines.forEach((orderline: any) => {
  //            this.dataService.lookupMap.skuMap[orderline.orderLineNo] = orderline.sku;
  //         });
  //         this.setMultiColumnOptions(pageRows);
  //       }, (err: any) => {
  //         this.alertService.clearAll().warn(this.resourceService.get(err));
  //       });

  //       break;
  //     }
  //     case 'lot': {
  //       const orderId = this.dataService.getPrimarySelectedDocument();
  //       this.dataService.lookupMap.lotMap = [];
  //       this.dataService.lookupMap.locMap = [];
  //       this.dataService.lookupMap.movIdMap = [];

  //       this.backendService.populateRestrictedValuesLotLocForOrder(orderId).subscribe((res: any) => {
  //         this.dataService.lookupMap.lotLines = res.lotlocIds;
  //         this.dataService.lookupMap.lotLines.forEach((lotLineList: any) => {
  //           this.dataService.lookupMap.lotMap[lotLineList.lineNumber] = lotLineList.lotList;
  //           this.dataService.lookupMap.locMap[lotLineList.lineNumber] = lotLineList.locMap;
  //           this.dataService.lookupMap.movIdMap[lotLineList.lineNumber] = lotLineList.movIdMap;
  //         });
  //         this.setMultiColumnOptions(pageRows);

  //       }, (err: any) => {
  //         this.alertService.clearAll().warn(this.resourceService.get(err));
  //       });

  //       break;
  //     }
  //   }
  // }
  // // method to set options for orderline, lot, loc and id dropdown
  // public setMultiColumnOptions(pageRows: any) {
  //   if (this.dataService.lookupMap.orderLines) {
  //     pageRows.forEach((row: any) => {
  //       row.cells['orderLineNo'].mcOptions = this.dataService.lookupMap.orderLines;
  //       row.cells['orderLineNo'].keyArray = Object.keys(this.dataService.lookupMap.orderLines[0]);
  //       // row.cells['orderLineNo'].isLoading = false;
  //     });
  //   }
  //   pageRows.forEach((row: any) => {
  //     const orderLineNo = row.cells['orderLineNo'].cVal;
  //     const lot = row.cells['lot'].cVal;
  //     const loc = row.cells['loc'].cVal;

  //     if (this.dataService.lookupMap.lotMap[orderLineNo]) {
  //       row.cells['lot'].mcOptions = this.dataService.lookupMap.lotMap[orderLineNo];
  //       if (this.dataService.lookupMap.locMap[orderLineNo][lot]) {
  //       row.cells['loc'].mcOptions = this.dataService.lookupMap.locMap[orderLineNo][lot];
  //       if (this.dataService.lookupMap.movIdMap[orderLineNo][lot][loc]) {
  //         row.cells['id'].mcOptions = this.dataService.lookupMap.movIdMap[orderLineNo][lot][loc];
  //       } else {
  //         row.cells['id'].mcOptions = [];
  //       }
  //       } else {
  //         row.cells['loc'].mcOptions = [];
  //         row.cells['id'].mcOptions = [];
  //       }
  //     } else {
  //       row.cells['lot'].mcOptions = [];
  //       row.cells['loc'].mcOptions = [];
  //       row.cells['id'].mcOptions = [];
  //     }
  //     row.cells['lot'].keyArray = this.dataService.lookupMap.keyArray;
  //     row.cells['loc'].keyArray = this.dataService.lookupMap.keyArray;
  //     row.cells['id'].keyArray = this.dataService.lookupMap.keyArray;
  //   });
  // }
  // // method used to autopopulate options for lot, loc and id fields based on changed fields.
  // public autoPopulate(row: any, colName: any) {
  //   const orderLineNo = row.cells['orderLineNo'].cVal;
  //   const lot = row.cells['lot'].cVal;
  //   const loc = row.cells['loc'].cVal;

  //   switch (colName) {
  //     case 'orderLineNo':
  //       {
  //         row.cells['lot'].cVal = '';
  //         row.cells['loc'].cVal = '';
  //         row.cells['id'].cVal = '';
  //         row.cells['lot']['isEdited'] = true;
  //         row.cells['loc']['isEdited'] = true;
  //         row.cells['id']['isEdited'] = true;

  //         if (this.dataService.lookupMap.skuMap[orderLineNo]) {
  //           row.cells['commodity'].cVal = this.dataService.lookupMap.skuMap[orderLineNo];
  //         } else {
  //           row.cells['commodity'].cVal = '';
  //         }
  //         row.cells['commodity']['isEdited'] = true;
  //         row['isEdited'] = true;
  //         if (this.dataService.lookupMap.lotMap[orderLineNo]) {
  //           row.cells['lot'].mcOptions = this.dataService.lookupMap.lotMap[orderLineNo];
  //           row.cells['loc'].mcOptions = [];
  //           row.cells['id'].mcOptions = [];
  //         } else {
  //           row.cells['lot'].mcOptions = [];
  //           row.cells['loc'].mcOptions = [];
  //           row.cells['id'].mcOptions = [];
  //         }
  //         row.cells['lot'].keyArray = this.dataService.lookupMap.keyArray;
  //         row.cells['loc'].keyArray = this.dataService.lookupMap.keyArray;
  //         row.cells['id'].keyArray = this.dataService.lookupMap.keyArray;
  //         break;
  //       }
  //     case 'lot': {
  //       row.cells['loc'].cVal = '';
  //       row.cells['id'].cVal = '';
  //       row.cells['loc']['isEdited'] = true;
  //       row.cells['id']['isEdited'] = true;
  //       row['isEdited'] = true;
  //       if (this.dataService.lookupMap.lotMap[orderLineNo] && this.dataService.lookupMap.locMap[orderLineNo][lot]) {
  //         row.cells['loc'].mcOptions = this.dataService.lookupMap.locMap[orderLineNo][lot];
  //         row.cells['id'].mcOptions = [];
  //       } else {
  //         row.cells['loc'].mcOptions = [];
  //         row.cells['id'].mcOptions = [];
  //       }
  //       row.cells['loc'].keyArray = this.dataService.lookupMap.keyArray;
  //       row.cells['id'].keyArray = this.dataService.lookupMap.keyArray;
  //       break;
  //     }
  //     case 'loc': {
  //       row.cells['id'].cVal = '';
  //       row.cells['id']['isEdited'] = true;
  //       row['isEdited'] = true;
  //       if (this.dataService.lookupMap.lotMap[orderLineNo] && this.dataService.lookupMap.movIdMap[orderLineNo][lot]
  //       && this.dataService.lookupMap.movIdMap[orderLineNo][lot][loc]) {
  //         row.cells['id'].mcOptions = this.dataService.lookupMap.movIdMap[orderLineNo][lot][loc];
  //       } else {
  //         row.cells['id'].mcOptions = [];
  //       }
  //       row.cells['id'].keyArray = this.dataService.lookupMap.keyArray;
  //       break;
  //     }
  //   }
  // }

  /**
   * This method handles the changes to the property value
   * @param event - Property Change Event
   */
  public propertyValueChanged(event: PropertyChangeEvent): boolean {
    if ( event && event.property === PICK_MNGT_CONSTANTS.ORDER_LINE_NO && event.value.length >= PICK_MNGT_CONSTANTS.LOOK_UP_LENGTH ) {
      event.row.cells[PICK_MNGT_CONSTANTS.ORDER_LINE_NO].cVal = event.value;
      this.validateOrderLineNo(event.row, event.property, null);
    }
    return true;
  }
  /**
   * This method is used to refresh the cells of the table
   * @param params - cell params
   */
  public refreshCells(params: any) {
    params.api.refreshCells({ rowNodes: [params.node] });
  }
  // LFWM-3557- adding validation to orderLineNo
  public validateOrderLineNo(currentRow: any, propertyName: any, gridOptions: any) {
    let currentRowCells = currentRow.cells;
    const currentCell = gridOptions ? gridOptions.api.getFocusedCell() : null;
    let orderKey = currentRowCells['orderKey'].cVal;
    let orderLineNo = currentRowCells['orderLineNo'].cVal;
    const colId = currentCell ? currentCell.column.colId : '';
    this.backendService.validateOrderLineNo(orderKey, orderLineNo)
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            currentRowCells[propertyName].isValueInvalid = false;
            if ( gridOptions ) {
              gridOptions.api.stopEditing();
              gridOptions.api.clearFocusedCell();
              gridOptions.api.startEditingCell({
                rowIndex: currentCell.rowIndex + 1,
                colKey: colId
              });
              gridOptions.api.setFocusedCell(currentCell.rowIndex + 1, colId);
            }
            this.getOrderLineDetails(orderKey, orderLineNo,currentRow);
          } else if (resp['statusCode'] === 400 && resp['statusMessage'] === 'FAILURE') {
            currentRowCells[propertyName].isValueInvalid = true;
            this.alertService.clearAll();
            const errorResp = this.resourceService.get('msg_the_order') + orderKey + ' ' + this.resourceService.get('msg_and_orderLine') + orderLineNo + ' ' + this.resourceService.get('tps_errmsg1');
            this.alertService.clearAll().error(errorResp);
            if ( gridOptions ) {
              gridOptions.api.stopEditing();
              gridOptions.api.clearFocusedCell();
              gridOptions.api.startEditingCell({
                rowIndex: currentCell.rowIndex,
                colKey: colId
              });
              gridOptions.api.setFocusedCell(currentCell.rowIndex, currentCell.column.colId);
            }

          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.get(error));
      });
  }
  public getOrderLineDetails(orderKey: string, orderLineNo: string, currentRow: any): any {
    const request = {
      "pageInfo":{
        "tableId": PICK_MNGT_CONSTANTS.ORDER_TABLE_TD,
        "pageNo": SEARCH_DEFAULT_PAGE_NUMBER,
        "sortColumn":null,
        "sortOrder": SORT_ORDER_ASC,
        "pageSize": SEARCH_DEFAULT_PAGE_SIZE,
        "fullFetch":true
      },
      "searchCriteria":{
        "conditions":[
          {
            "mandatory":true,
            "clauses":[
              {
                "column" : PICK_MNGT_CONSTANTS.ORDER_KEY,
                "operation" : SEARCH_OPERATORS.EQUAL,
                "value" : orderKey,
                "logicalOperation" : ""
              },
              {
                "column" : PICK_MNGT_CONSTANTS.ORDER_LINE_NO,
                "operation" : SEARCH_OPERATORS.EQUAL,
                "value" : orderLineNo,
                "logicalOperation" : SEARCH_OPERATORS.AND
              }
            ],
            "logicalOperation":null
          }
        ]
      }
    };
    this.backendService.getOrderLineDetails(request).subscribe((res: any) => {
      if (res && res['statusCode'] === HttpStatusCode.ok && res['statusMessage'] === 'SUCCESS') {
        let orderLineDetails = [];
        res.pageData.rows.forEach(x=>{
          const orderLineCell = x.cells.find(y=>y.cName === PICK_MNGT_CONSTANTS.ORDER_LINE_NUMBER);
          if(orderLineCell && orderLineCell.cVal === orderLineNo){
            orderLineDetails = x.cells;
          }
        });
        if (orderLineDetails.length !== 0) {
          const skuCell = orderLineDetails.find(x => x.cName === COMMON_FIELDS.SKU);
          if (skuCell) {
            currentRow.cells[PICK_MNGT_CONSTANTS.COMMODITY].cVal = skuCell.cVal;
          }
          currentRow.cells[PICK_MNGT_CONSTANTS.COMMODITY].isEdited = true;
          const storerKeyCell = orderLineDetails.find(x => x.cName === COMMON_FIELDS.STORER_KEY);
          if (storerKeyCell) {
            currentRow.cells[COMMON_FIELDS.STORER_KEY].cVal = storerKeyCell.cVal;
          }
          currentRow.cells[COMMON_FIELDS.STORER_KEY].isEdited = true;
          const facilityCell = orderLineDetails.find(x => x.cName === COMMON_FIELDS.FACILITY);
          if (facilityCell) {
            currentRow.cells[COMMON_FIELDS.FACILITY].cVal = facilityCell.cVal;
          }
          currentRow.cells[COMMON_FIELDS.FACILITY].isEdited = true;
          const packKeyCell = orderLineDetails.find(x => x.cName === PICK_MNGT_CONSTANTS.PACK_KEY);
          if (packKeyCell) {
            currentRow.cells[PICK_MNGT_CONSTANTS.PACK_KEY].cVal = packKeyCell.cVal;
          }
          currentRow.cells[PICK_MNGT_CONSTANTS.PACK_KEY].isEdited = true;
          LOTTABLE_FIELDS.forEach((lottableField, index) => {
            const lottableCell = orderLineDetails.find(x => x.cName === lottableField);
            if (lottableCell) {
              this[lottableField] = lottableCell ? lottableCell.cVal : undefined;
            }
          })
          currentRow.isEdited = true;
        }
      }
    }, (err: any) => {
      this.alertService.clearAll().warn(this.resourceService.get(err));
    });
  }
  //LFWM-5053- separate method written for the popups to avoid ambiguity
  public openMultiColumnPopup(currentRow: any, property: any, primeFocus: any) {
    const currentRowCells = currentRow.cells;
    const isValid = this.validateBeforeMultiColumnPopup(currentRowCells, property);
    if (isValid !== true) {
      this.alertService.clearAll().error(this.resourceService.get('loc_id_mandatory'));
      return;
    }
    const modalService = this.sharedServiceRegistry.sceModalService;   
    const modalRef: any = modalService.showModal(MultiColumnPopupComponent,{
      overlayHeader: 'Warehouse Order# ' + currentRowCells['orderKey'].cVal,
      showHeader: true,
      overlayHeight: 520,
      overlayWidth: 1024
    });
    modalRef.content.currentRow = currentRow;
    modalRef.content.property = property;
    modalRef.content.alertService = this.alertService;
    modalRef.content.initializeComponents(this);
    modalRef.content.receiveEvent().subscribe((event: any) => {
      if (event.type === 'populate') {
        this.handleMultiColumnPopupEvent(event, property, currentRow)        
          this.sharedServiceRegistry.sceModalService.modalReference.hide();        
        if (primeFocus) {
          setTimeout(() => {
            primeFocus.nativeElement.focus();
            primeFocus.nativeElement.select();
          }, 5);
        }
      }
    });
  }

  /**
   * handleMultiColumnPopupEvent
   */
  // LFWM-3557- overridden this method to initialize value of orderLineNo isValueInvalid as false.
  public handleMultiColumnPopupEvent(event: any, property: string, currentRow: any) {
    //LFWM-4131- get channel id based on channel, sku,lot, facility
    this.getChannelId(event);
    const columnKey = Object.keys(event.selectedItems);
    if (columnKey.indexOf('orderLineNo') > -1) {
      currentRow.cells['lot'].cVal = '';
      currentRow.cells['loc'].cVal = '';
      currentRow.cells['id'].cVal = '';
      currentRow.cells['orderLineNo'].cVal = event.selectedItems['orderLineNo'];
      currentRow.cells['orderLineNo'].isEdited = true;
      currentRow.cells['orderLineNo'].isValueInvalid = false;
      currentRow.cells['commodity'].cVal = event.selectedItems['commodity'];
      currentRow.cells['commodity'].isEdited = true;
      currentRow.cells['storerKey'].cVal = event.selectedItems['storerKey'];
      currentRow.cells['storerKey'].isEdited = true;
      currentRow.cells['facility'].cVal = event.selectedItems['facility'];
      currentRow.cells['facility'].isEdited = true;
      currentRow.cells['packKey'].cVal = event.selectedItems['packKey'];
      currentRow.cells['packKey'].isEdited = true;
      this.lottable01 = event.selectedItems['lottable01']; 
      this.lottable02 = event.selectedItems['lottable02']; 
      this.lottable03 = event.selectedItems['lottable03']; 
      this.lottable04 = event.selectedItems['lottable04']; 
      this.lottable05 = event.selectedItems['lottable05']; 
      this.lottable06 = event.selectedItems['lottable06']; 
      this.lottable07 = event.selectedItems['lottable07']; 
      this.lottable08 = event.selectedItems['lottable08']; 
      this.lottable09 = event.selectedItems['lottable09']; 
      this.lottable10 = event.selectedItems['lottable10']; 
      this.lottable11 = event.selectedItems['lottable11']; 
      this.lottable12 = event.selectedItems['lottable12']; 
      this.lottable13 = event.selectedItems['lottable13']; 
      this.lottable14 = event.selectedItems['lottable14']; 
      this.lottable15 = event.selectedItems['lottable15']; 
      currentRow.isEdited = true;
    }
    if (columnKey.indexOf('lot') > -1) {
      currentRow.cells['lot'].cVal = event.selectedItems['lot'];
      currentRow.cells['lot'].isEdited = true;
      if (columnKey.indexOf(META_DATA.LOC) > -1) {
        currentRow.cells[META_DATA.LOC].cVal = event.selectedItems[META_DATA.LOC];
        currentRow.cells[META_DATA.LOC].isEdited = true;
      }
      if (columnKey.indexOf(META_DATA.ID) > -1) {
        currentRow.cells[META_DATA.ID].cVal = event.selectedItems[META_DATA.ID];
        currentRow.cells[META_DATA.ID].isEdited = true;
      }
      currentRow.cells['Lottable01'].cVal = event.selectedItems['Lottable01'];
      currentRow.cells['Lottable02'].cVal = event.selectedItems['Lottable02'];
      currentRow.cells['Lottable03'].cVal = event.selectedItems['Lottable03'];
      currentRow.cells['Lottable04'].cVal = event.selectedItems['Lottable04'];
      currentRow.cells['Lottable05'].cVal = event.selectedItems['Lottable05'];
      currentRow.cells['Lottable06'].cVal = event.selectedItems['Lottable06'];
      currentRow.cells['Lottable07'].cVal = event.selectedItems['Lottable07'];
      currentRow.cells['Lottable08'].cVal = event.selectedItems['Lottable08'];
      currentRow.cells['Lottable09'].cVal = event.selectedItems['Lottable09'];
      currentRow.cells['Lottable10'].cVal = event.selectedItems['Lottable10'];
      currentRow.cells['Lottable11'].cVal = event.selectedItems['Lottable11'];
      currentRow.cells['Lottable12'].cVal = event.selectedItems['Lottable12'];
      currentRow.cells['Lottable13'].cVal = event.selectedItems['Lottable13'];
      currentRow.cells['Lottable14'].cVal = event.selectedItems['Lottable14'];
      currentRow.cells['Lottable15'].cVal = event.selectedItems['Lottable15'];
      currentRow.isEdited = true;
    }
    if (columnKey.indexOf('loc') > -1) {
      currentRow.cells['id'].cVal = '';
      currentRow.cells['id'].isEdited = true;
      currentRow.cells['loc'].cVal = event.selectedItems['loc'];
      currentRow.cells['loc'].isEdited = true;
      currentRow.isEdited = true;
    }
    if (columnKey.indexOf('id') > -1) {
      currentRow.cells['id'].cVal = event.selectedItems['id'];
      currentRow.cells['id'].isEdited = true;
      currentRow.isEdited = true;
    }        
    this.changeDisplayType( currentRow);
    
  }

  changeDisplayType(currentRow){         
    this.dataService.searchServices[0].getMetadata().columnList.forEach(col=>{
      if(col.propertyName === 'channelID')
        col.displayType = 'V';
    });    
  }

  getChannelId(event){
    if(event.selectedItems['channel'] ) {
      this.backendService.getChannelId(event).subscribe((res : any)=>{
        this.channelId = res.channelId;
        this.dataService.searchServices[0].getPagedData().focusedRow.cells.channelID.cVal = this.channelId;
        this.dataService.searchServices[0].getPagedData().focusedRow.cells.channelID.isEdited = true;        
      });
    } else {
        this.dataService.searchServices[0].getPagedData().focusedRow.cells.channelID.cVal = 0;
        this.dataService.searchServices[0].getPagedData().focusedRow.cells.channelID.isEdited = true;
    }

  }

  public async getIfCaseIDIsEnabled(storerKey: string, facilityKey: string) {
    return await this.backendService.getStorerConfigurationForFacility(facilityKey, storerKey, CASE_ID_CONFIG_KEY, TABLE_NAMES.PICK_TD).toPromise();
  }

  public async getIfQuantityIsEnabled(storerKey: string, facilityKey: string) {
    const configKey = 'SCEDontAllowEditPickDetQty';
    const tableId = 'picktd'; 
    return await this.backendService.getStorerConfigurationForFacility(facilityKey, storerKey, configKey,tableId).toPromise();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/pick-management/services/pick-management-editor.service.ts